/**
 * The landing for `avengents pair`'s printed link — owner, 2026-08-13: 9445 的
 * 配對 link 無法使用.
 *
 * The CLI prints `<base>/devices?code=XXXX-XXXX`. That page only ever existed
 * on the :9443 site; on an app origin the SPA shell answered 200 and then
 * ignored the code entirely — a pairing link that "works" (page loads) and does
 * nothing, the exact shape of the report. This banner is the missing landing:
 * if the URL carries a plausible code, say so and offer the one action that
 * matters. The approve href is a REAL navigation (into the Google leg), not a
 * fetch, and it is built by approveUrl — same-origin here, so the whole dance
 * stays on the port the person started on.
 *
 * Read ONCE at mount. The code is untrusted input from a URL: it is validated
 * against the code shape, re-encoded by approveUrl, and never echoed into
 * markup beyond text. Dismissing strips it from the URL so a later reload does
 * not resurrect a stale prompt — codes rotate every few minutes anyway.
 */
import { useState } from 'react'
// CODE_SHAPE lives with the other judgements of a code (pairCode.ts) since the typed
// field joined the scanner (2026-09-13) — one alphabet, read by both doors.
import { approveUrl, CODE_SHAPE } from './pairCode'

export function readCodeFromUrl(search: string = window.location.search): string | null {
  const raw = new URLSearchParams(search).get('code')?.trim().toUpperCase() ?? ''
  return CODE_SHAPE.test(raw) ? raw : null
}

export function PairApprove() {
  const [code, setCode] = useState<string | null>(() => readCodeFromUrl())
  if (!code) return null

  const dismiss = () => {
    const q = new URLSearchParams(window.location.search)
    q.delete('code')
    const s = q.toString()
    window.history.replaceState(null, '', `${window.location.pathname}${s ? `?${s}` : ''}`)
    setCode(null)
  }

  return (
    <div
      role="dialog"
      aria-label="Pairing approval"
      style={{
        position: 'fixed',
        top: 12,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 90,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '10px 14px',
        borderRadius: 10,
        background: 'var(--c313244, #313244)',
        color: 'var(--ccdd6f4, #cdd6f4)',
        boxShadow: '0 4px 18px rgba(0,0,0,0.35)',
        maxWidth: 'calc(100vw - 24px)',
      }}
    >
      <span>
        A machine is waiting to pair — code <b>{code}</b>
      </span>
      <a
        href={approveUrl(code)}
        style={{
          padding: '6px 12px',
          borderRadius: 8,
          background: 'var(--ca6e3a1, #a6e3a1)',
          color: 'var(--c11111b, #11111b)',
          textDecoration: 'none',
          whiteSpace: 'nowrap',
        }}
      >
        Approve pairing
      </a>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss"
        style={{
          border: 'none',
          background: 'transparent',
          color: 'inherit',
          cursor: 'pointer',
          fontSize: 15,
        }}
      >
        ✕
      </button>
    </div>
  )
}
